import { render, staticRenderFns } from "./SchedulePage.vue?vue&type=template&id=66db7cfe&scoped=true"
import script from "./SchedulePage.vue?vue&type=script&lang=ts"
export * from "./SchedulePage.vue?vue&type=script&lang=ts"
import style0 from "./SchedulePage.vue?vue&type=style&index=0&id=66db7cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db7cfe",
  null
  
)

export default component.exports